import getT from 'next-translate/getT'
import {SEND_TOXICITY_REPORT_TO_SLACK, STRIPE_USAGE} from '../constants/routes'
import modelStore from '../stores/modelStore'
import axios from './axiosAPI'

export const getRemainingUsage = async (userId: string) => {
  const response = await axios.get(STRIPE_USAGE(userId))
  if (response.data) {
    return response.data.remainingUsage
  } else {
    throw new Error('an error occurred')
  }
}

export const reportModelContentToSlack = async () => {
  const input = modelStore.getState().input
  const output = modelStore.getState().output
  const maxLength = modelStore.getState().maxLength
  const temperature = modelStore.getState().temperature
  const topP = modelStore.getState().topP
  await reportContentToSlack(input, output, maxLength, temperature, topP)
}

const reportContentToSlack = async (
  input: string,
  output: string,
  maxLength?: number,
  temperature?: number,
  topP?: number
) => {
  const t = await getT()
  const showToast = await import('../utils/showToast').then(mod => mod.showToast)
  try {
    await axios.post(SEND_TOXICITY_REPORT_TO_SLACK, {
      input,
      output,
      maxLength,
      temperature,
      topP,
    })

    showToast(t('model:toxic_toast_reporting_message_successfully_send'), 'success')
  } catch (e: any) {
    if (e?.isAxiosError) {
      showToast(e.response.data, 'error')
    } else {
      showToast(t('common:generic_error'), 'error')
    }
  }
}
